"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearTokens = clearTokens;
exports.storeTokens = storeTokens;
exports.retrieveTokens = retrieveTokens;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _localforage = _interopRequireDefault(require("localforage"));

var Consts = _interopRequireWildcard(require("../../constants"));

var _config = _interopRequireDefault(require("../config"));

var _marked =
/*#__PURE__*/
_regenerator.default.mark(clearTokens),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(storeTokens),
    _marked3 =
/*#__PURE__*/
_regenerator.default.mark(retrieveTokens);

function clearTokens() {
  return _regenerator.default.wrap(function clearTokens$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          window.sessionStorage.removeItem(_config.default.tokensKey);
          _context.next = 3;
          return _localforage.default.removeItem(_config.default.tokensKey);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

function storeTokens(tokens) {
  return _regenerator.default.wrap(function storeTokens$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.t0 = _config.default.options.tokens.persistence;
          _context2.next = _context2.t0 === Consts.tokens.persistence.LOCAL ? 3 : _context2.t0 === Consts.tokens.persistence.SESSION ? 7 : 11;
          break;

        case 3:
          window.sessionStorage.removeItem(_config.default.tokensKey);
          _context2.next = 6;
          return _localforage.default.setItem(_config.default.tokensKey, tokens);

        case 6:
          return _context2.abrupt("break", 11);

        case 7:
          _context2.next = 9;
          return _localforage.default.removeItem(_config.default.tokensKey);

        case 9:
          window.sessionStorage.setItem(_config.default.tokensKey, JSON.stringify(tokens));
          return _context2.abrupt("break", 11);

        case 11:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function retrieveTokens() {
  var stringifiedTokens;
  return _regenerator.default.wrap(function retrieveTokens$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.t0 = _config.default.options.tokens.persistence;
          _context3.next = _context3.t0 === Consts.tokens.persistence.LOCAL ? 3 : _context3.t0 === Consts.tokens.persistence.SESSION ? 7 : 11;
          break;

        case 3:
          window.sessionStorage.removeItem(_config.default.tokensKey);
          _context3.next = 6;
          return _localforage.default.getItem(_config.default.tokensKey);

        case 6:
          return _context3.abrupt("return", _context3.sent);

        case 7:
          _context3.next = 9;
          return _localforage.default.removeItem(_config.default.tokensKey);

        case 9:
          stringifiedTokens = window.sessionStorage.getItem(_config.default.tokensKey);
          return _context3.abrupt("return", JSON.parse(stringifiedTokens));

        case 11:
          return _context3.abrupt("return", null);

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}